// Shared language metadata and product-text helpers. Full UI copy loads per language.
export const LANG_FLAGS = { da: "dk", en: "gb", sv: "se" };
export const LANG_LABELS = { da: "Dansk", en: "English", sv: "Svenska" };
export const LANGUAGE_IDS = ["da", "en", "sv"];

const loaders = {
  da: () => import("./locales/da"),
  en: () => import("./locales/en"),
  sv: () => import("./locales/sv"),
};

export async function loadTranslations(languageId) {
  const language = LANGUAGE_IDS.includes(languageId) ? languageId : "da";
  const module = await loaders[language]();
  return module.default;
}

export const pText = (lang, product, field, texts) => {
  if (!product) return "";
  const row = texts?.[String(product.product_id ?? "")];
  const v = row?.[field];
  if (Array.isArray(v) ? v.length > 0 : Boolean(v)) return v;
  return product[field] ?? "";
};

// Felter der aldrig må falde tilbage til PRODUKTER (fx billeder og forsideflag).
export const pTextOnly = (product, field, texts) =>
  texts?.[String(product?.product_id ?? "")]?.[field] ?? "";

export const pTextFlag = (product, field, texts) => {
  const value = pTextOnly(product, field, texts);
  return value === true || String(value).toLowerCase() === "true";
};

